<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
                <m-search-item label="服务标题">
                    <c-input name="product_name" placeholder="模糊匹配"></c-input>
                </m-search-item>
				<m-search-item label="问题内容">
                    <c-input name="content" placeholder="模糊匹配"></c-input>
				</m-search-item>
                <m-search-item label="状态">
                    <c-select name="state" :options="stateData"></c-select>
                </m-search-item>
				<m-search-item label="提问时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
				</m-search-item>
			</m-search>
			
<!--			<m-operate>
				<c-button v-if="auth('b_product_edit')" color="main" @click="selectClassify">发布服务</c-button>
			</m-operate>-->
			
			<c-table ref="table" height="grow">
				<c-table-column
					type="selector"
				></c-table-column>

				<c-table-column
					label="服务信息"
					width="350"
				>
                    <template #default="{data}">
                        <product-info :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
				</c-table-column>

                <c-table-column
                        label="问题内容"
                        width="300"
                >
                    <template #default="{data}">
                        <span>{{data.content}}</span>
                    </template>
                </c-table-column>

				<c-table-column
					label="状态"
					width="80"
					name="state"
				>
                    <template v-slot="{data}">
                        <c-switch :value="data.state" :state-value="[2,1]" :state-text="['启用','禁用']"
                                  @beforeChange="beforeChangeState(arguments[0], arguments[1], data)"
                        >
                        </c-switch>
                    </template>
				</c-table-column>
				
				<c-table-column
                    label="回答数量"
                    name="answer_count"
                    width="80"
                >
				    <template #default="{data}">
				        <span v-if="data.answer_count > 0" style="color:blue">{{data.answer_count}}</span>
				        <span v-else style="color: darkgray">0</span>
				    </template>
				</c-table-column>

				<c-table-column
					label="提问时间"
					width="150"
				>
					<template v-slot="{data}">
						<p>{{data.create_date}}</p>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="170"
				>
					<template #default="{data}">
                        <c-button @click="navigateTo({path: `/product_answer_list`, query: {questionId: data.id}})">查看回答</c-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import productInfo from '@/components/public/product_info.vue'

	export default {
		components: {
			productInfo
		},
		
		props: {
            productId: String
		},
		
		data() {
			return {
                stateData: [
                    {name: '禁用',value: '1'},
                    {name: '启用',value: '2'}
                ]
			}
		},
		
		computed: {
			...mapState(['userInfo','systemConfig'])
		},
		
		mounted() {
            this.$refs.search.search();
        },

		methods: {
			searchHandle(data) {
                if (this.productId){
                    data.product_id = this.productId;
                }
				this.$refs.table.load({
					url: '/product/question/list',
					data: data
				});
			},
            /***
             * 启用禁用前 回调函数
             */
            beforeChangeState(state,next,data){
                // 确认弹窗
                this.$confirm({
                    title: (state?'禁用':'启用')+'问题',
                    message: '是否确定【'+(state?'禁用':'启用')+'】问题【'+data.content+'】？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product/question/edit_state',
                            data: {
                                question_id:data.id,
                                state:state?1:2
                            },
                            loading: true,
                            success: data => {
                                //远程接口调用完成，执行next方法，变更开关状态（执行失败则不变更状态）
                                next();
                                // 消息弹窗
                                this.$message({
                                    message: (state?'禁用':'启用')+'成功',  // 提示内容,
                                    type: 'success'
                                });
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
    .tip-text {
        border-radius: 5px;
        background-color: #0060ef;
        color: #E1CB57;
        opacity: 0.5;
        padding: 5px;
        width: 98%;
        height:15px;
    }
	.classify-select {
		padding: 10px;
		
		dl {
			width: 360px;
			border: 1px solid #ddd;
			
			&:nth-child(n+2) {
				border-left: none;
			}
			
			dt {
				position: relative;
				padding: 10px;
			
				.tf {
					position: absolute;
					width: 30px;
					line-height: 36px;
					font-size: 14px;
					text-align: center;
					color: #bbb;
				}
				
				input {
					box-sizing: border-box;
					width: 100%;
					height: 36px;
					border: none;
					padding: 0 10px 0 30px;
					background: #F5F5F5;
				}
			}
			
			dd {
				height: 290px;
				overflow: auto;
				
				li {
					padding: 0 14px;
					line-height: 36px;
					font-size: 13px;
					cursor: pointer;
					
					&:hover,
					&.z-crt {
						background: #FFF17E;
					}
				}
			}
		}
	}
</style>
